module.exports = __webpack_public_path__ + "img/about_swiper1.f8cadc36.jpg";